import { Injectable } from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Router} from '@angular/router';
import {environment} from '../../environments/environment';
import {Permitions} from '../models/permitions';
import {TxtConv} from '../helpers/txt-conv';
import {map} from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class SessionService {


  // region Atributos
  public JWToken = 'TK1983!';
  public profileToken = 'PF849!';
  //public permissionsToken = 'AC2358!';
  //public contractIDToken = 'CT7384';

  public role;
  public url: string;
  //public profile: any;


  // endregion

  // region Constructor
  constructor(
    public httpClient: HttpClient,
    public router: Router
  ) {
    this.url = environment.url;
  }


  // endregion

  // region Métodos

  // Obtiene el token guardado en sessionStorage, si no existe devuelve null
  getToken() {
    const token = sessionStorage.getItem(this.JWToken);
    if (token != 'undefined') {
      return token;
    } else {
      return null;
    }
  }


  // Obtiene el array de acciones por modulo del usuario
  // getPermitionsModules(): Permitions[] {
  //   const permitions = JSON.parse(atob(sessionStorage.getItem(this.permissionsToken)));
  //   if (permitions || permitions.length > 0) {
  //     for (let i = 0; i < permitions.length; i++) {
  //       permitions[i].action = TxtConv.txtCon(permitions[i].action, 'uppercase');
  //       permitions[i].module = TxtConv.txtCon(permitions[i].module, 'uppercase');
  //     }
  //     return permitions as Permitions[];
  //   } else {
  //     return null;
  //   }
  // }

  // Verifica si la acción o acciones se encuentran dentro del perfil del uuario
  // verifyActions(checkActions: [any]): boolean {
  //   const actions = JSON.parse(atob(sessionStorage.getItem(this.permissionsToken)));
  //   if (actions || actions.length > 0) {
  //     for (let i = 0; i < checkActions.length; i++) {
  //       for (let j = 0; j < actions.length; j++) {
  //         actions[j].name = TxtConv.txtCon(actions[j].name, 'uppercase');
  //         actions[j].module = TxtConv.txtCon(actions[j].module, 'uppercase');
  //         if (actions[j].name === checkActions[i]) {
  //           return true;
  //         }
  //       }
  //     }
  //   } else {
  //     return false;
  //   }
  // }

  // Obtiene el objeto de tipo user que esta guardado en sessionStorage
  // getProfile(): Profile {
  //   const profile = JSON.parse(atob(sessionStorage.getItem(this.profileToken)));
  //   if (profile) {
  //     return profile as Profile;
  //   } else {
  //     return null;
  //   }
  // }

  public setToken(token: string): void {
    sessionStorage.setItem(this.JWToken, token);
  }


  // Función para guardar el id temp del contrato
  // setContractId(idcontract) {
  //   localStorage.setItem(this.contractIDToken, btoa(idcontract));
  // }

  // Función para obtener el id temp del contrato
  // getContractId() {
  //   return atob(sessionStorage.getItem(this.contractIDToken));
  // }

  // Obtiene el rol almacenado en sessionStorage, si no existe devuleve null
  public getRole(): string {
    const role = sessionStorage.getItem(JSON.parse(this.profileToken).role);
    if (role != 'undefined') {
      return  role;
    } else {
      return null;
    }
  }

  // Función para enviar las credendiales de autenticación con el backend
  signup(data): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.httpClient.post(this.url + '/administrator/login', data, {headers: headers});
  }

  // función amigable para verificar si existe el token de sesión
  public isLogged(): boolean {
    const token = this.getToken();
    return token !== null;
  }

  // Función para cerrar sesión, elimina lo almacenado en sessionStorage
  logout() {
    sessionStorage.clear();
    // Redireccionar
    this.router.navigate(['login']);
  }

  reloadPage() {
    setTimeout(() => {
      window.location.reload();
    }, 1500);
  }





  // endregion

}
